export const cropText = (input: string, size: number) =>
  input?.length && input?.length > size ? `${input.substring(0, size)}...` : input;
